export default "__VITE_ASSET__BVuFn4mY__"